'use client';

import { useSearchParams } from 'next/navigation';
import { Suspense } from 'react';

import { TopicBySearch } from '@/components/Topic/TopicBySearch';

const Content = () => {
  const searchParams = useSearchParams();

  const query = searchParams.get('query');

  return <TopicBySearch search={query ?? ''} />;
};

export function SearchView() {
  return (
    <Suspense fallback={null}>
      <Content />
    </Suspense>
  );
}
